import { History } from 'history';

import { focusCard } from '../../../components/prescriptionPad/rightPanel/workspace/focusCard';
import { GO_TO_PRESCRIPTION_PAD_V2, PP_SUB_ROUTES, PX_STATE } from '../../../routes/paths';
import { AntTooltip } from '../../../components/common/AntTooltip';
import { parseDoctorName } from '../../utils';
import startCase from 'lodash/startCase';

export const changePathAndFocus = (
    componentId: string,
    history: History,
    pxId: string,
    pxState: PX_STATE,
    subRoute?: PP_SUB_ROUTES,
    subRouteParam?: string,
    scrollOptions?: boolean | ScrollIntoViewOptions,
    skipFocus?: boolean,
): void => {
    history.replace(GO_TO_PRESCRIPTION_PAD_V2(pxId, pxState, subRoute, subRouteParam));
    if (!skipFocus) {
        setTimeout(() => {
            focusCard(componentId, scrollOptions);
        }, 200);
    }
};

export const BusinessDoctorName: React.FC<{ docName?: string }> = ({ docName }) => {
    const doctorName = parseDoctorName(docName);
    return (
        <AntTooltip content={`Prescription created by: ${startCase(docName)}`} placement="bottom">
            <p
                className="uppercase relative -top-3 min-w-28 min-h-28 rounded-full flex items-center justify-center text-11 cursor-pointer"
                style={{
                    color: '#19A66A',
                    background: '#D1EDE1',
                }}
            >
                {doctorName}
            </p>
        </AntTooltip>
    );
};
